import { Component, inject, Input, OnInit } from '@angular/core';
import { User } from '../../../_shared/models/user.model';
import { NgClass } from '@angular/common';
import { images } from '../../../_shared/data/image';
import { ThemeService } from '../../../_core/services/theme.service';
import { DisciplineEnum } from '../../../_shared/models/csTypes/enums/discipline';
import { Point } from '../../../_shared/models/point.model';
interface PlayerInfo {
  person?: User;
  showServerNumber?: number;
}
@Component({
  selector: 'app-pickleball-court',
  templateUrl: './pickleball-court.component.html',
  styleUrls: ['./pickleball-court.component.scss'],
  standalone: true,
  imports: [NgClass]
})

export class PickleballCourtComponent implements  OnInit {
  themeService = inject(ThemeService);
  @Input({ required: true }) topLeftPlayer!: PlayerInfo;
  @Input({ required: true }) bottomLeftPlayer!: PlayerInfo;
  @Input({ required: true }) topRightPlayer!: PlayerInfo;
  @Input({ required: true }) bottomRightPlayer!: PlayerInfo;
  @Input({ required: true }) serverNumber!: number;
  @Input({ required: true }) returningSide!: string;
  @Input({ required: false }) areSidesReveresed!: boolean;
  @Input({ required: false }) matchStatus!: boolean;
  @Input({ required: true }) discipline!: string;
  @Input({ required: true }) matchType!: string;
  @Input({ required: false }) server!: any;
  @Input({ required: false }) point!: Point;
  public ballIcon: string = images.pickleball;

  constructor() {

  }
  ngOnInit(): void {
    if(this.discipline == DisciplineEnum.BADMINTON ){
      this.ballIcon = images.badminton;
    } else if(this.discipline == DisciplineEnum.PICKLEBALL){
      this.ballIcon = images.pickleball;
    }
  }

  /**
   * Checks if a player in a specific position is the returner or server for table tennis
   * @param sideNumber The side number (1 or 2) - accounting for areSidesReveresed
   * @param courtSide The court side ('ad' or 'deuce')
   * @returns true if the player in that position is the returner or server
   */

    isReturnerInPosition(sideNumber: number, courtSide: 'ad' | 'deuce'): boolean {
    if (this.discipline !== DisciplineEnum.TABLE_TENNIS || !this.server || !this.point?.playerPositions) {
      return false;
    }

    const playerPositions = this.point.playerPositions;
    const sidePosition = playerPositions[`side${sideNumber}`];
    const player = sidePosition?.[courtSide];
    
    if (!player?.playerNumber) {
      return false;
    }

    // Check if this player is the returner
    const isReturner = (
      this.server.returnerSideNumber === sideNumber &&
      this.server.returnerPlayerNumber === player.playerNumber
    );

    // Check if this player is the server
    const isServer = (
      this.server.sideNumber === sideNumber &&
      this.server.playerNumber === player.playerNumber
    );

    // Return true if player is either returner or server
    return isReturner || isServer;
  }
}
